<template>
	<nuxt-link
		:to="link"
		:exact="link === '/'"
		class="flex w-full items-center px-4 py-2.5 text-neutral-800 transition-colors duration-200 hover:bg-neutral-100 focus:outline-none xl:rounded-r-md"
		exact-active-class="border-l-4 border-black bg-black/5 pl-3 text-black [&_[data-sidebar-icon]]:text-black [&_[data-sidebar-label]]:text-black"
	>
		<div
			class="mr-5 flex w-6 shrink-0 justify-center text-neutral-500 transition-colors duration-200"
			data-sidebar-icon
			title="label"
			v-tooltip:right="tooltip ? label : null"
		>
			<Icon v-if="icon" :icon="['fal', icon]" :size="iconSize"></Icon>
		</div>
		<div class="w-full text-[15px] tracking-[0.25px] text-neutral-800" data-sidebar-label>
			<slot>
				{{ label }}
			</slot>
		</div>
	</nuxt-link>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	name: 'SidebarItem',
	components: {
		Icon
	},
	props: {
		link: {
			type: String,
			default: '/'
		},
		label: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: null
		},
		iconSize: {
			type: String,
			default: null
		},
		tooltip: {
			type: Boolean,
			default: false
		}
	}
}
</script>
